import once from 'lodash/once';
import { track } from '../facade';

const dispatch = action => track(action, {
  category: `Cookie consent`,
  label: null,
  value: null
});

export const show = once(() => dispatch('Show Prompt'));
export const close = once(() => dispatch('Close Prompt'));

